import { render } from "./DianFei.vue?vue&type=template&id=0eabeea4"
import script from "./DianFei.vue?vue&type=script&lang=js"
export * from "./DianFei.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__